export const getAllPromptOverridesConfig = () => ({
  url: `/get_all_prompt_overrides`,
});

export const createOverridesConfig = () => ({
  url: `/prompt_overrides`,
});

export const getOverridesByIdConfig = (prompt_override_id) => ({
  url: `/prompt_overrides/${prompt_override_id}`,
});

export const editOverridesConfig = (prompt_override_id) => ({
  url: `/prompt_overrides/${prompt_override_id}`,
});

export const deletePromptOverridesConfig = (prompt_override_id) => ({
  url: `/delete_prompt_override/${prompt_override_id}`,
});

export const getAllConditionsOverrideConfig = () => ({
  url: `/get_conditions_promptoverride`,
});

export const getAllPromptScreenOverrideConfig = () => ({
  url: `/practitioner/condition_prompt_override`,
});

export const getFilterPromptOverrideConfig = () => ({
  url: `/filter_prompt_override`,
});
